module.exports = __webpack_public_path__ + "static/media/674.5639162f.webp";